import { JustpayCommonEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-common-endpoint-service"

export class JustpayCommonService {
    constructor () {
        this.justpayEndpointCommonService = new JustpayCommonEndpointService()
    }

    // Get offline points
    async getOfflinePoints (clientId, tableOptions) {
        let points = null
        if (tableOptions !== undefined) {
            points = await this.justpayEndpointCommonService.getOfflinePoints(clientId, tableOptions)
        } else {
            points = await this.justpayEndpointCommonService.getOfflinePoints(clientId, {
                page: 1,
                itemsPerPage: 10
            })
        }
        return points
    }

    async getPm (clientId) {
        return this.justpayEndpointCommonService.getPm(clientId)
    }

    // Get  points with address
    async getPa (clientId, tableOptions) {
        let points = null
        if (tableOptions !== undefined) {
            points = await this.justpayEndpointCommonService.getPa(clientId, tableOptions)
        } else {
            points = await this.justpayEndpointCommonService.getPa(clientId, {
                page: 1,
                itemsPerPage: 10
            })
        }
        return points
    }
}
